import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { LayoutGrid, List, GalleryHorizontal } from "lucide-react";
import { UpgradeNote } from "./UpgradeNote";

const PRESETS = ["#10b981", "#f97316", "#2563eb", "#e11d48", "#7c3aed", "#0f172a", "#ca8a04", "#0891b2"];
const LAYOUTS = [
  { id: "grid", label: "Grid", desc: "Classic product grid", icon: LayoutGrid },
  { id: "list", label: "List", desc: "Wide rows with details", icon: List },
  { id: "showcase", label: "Showcase", desc: "Big hero product + grid", icon: GalleryHorizontal },
];

export const ThemeSection = ({ form, setField, allowed }) => (
  <div className="space-y-6">
    {!allowed && <UpgradeNote feature="Custom theme colour & layout" testId="theme-upgrade-note" />}
    <fieldset disabled={!allowed} className={allowed ? "" : "opacity-50"}>
      <Label>Theme Colour</Label>
      <div className="flex flex-wrap items-center gap-3 mt-2">
        {PRESETS.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setField("theme_color", c)}
            className={`w-9 h-9 rounded-full border-4 transition-transform hover:scale-110 ${form.theme_color === c ? "border-gray-900" : "border-white shadow"}`}
            style={{ backgroundColor: c }}
            aria-label={c}
            data-testid={`theme-color-${c.slice(1)}`}
          />
        ))}
        <Input
          value={form.theme_color || ""}
          onChange={(e) => setField("theme_color", e.target.value)}
          placeholder="#10b981"
          className="w-32 font-mono"
          data-testid="theme-color-input"
        />
      </div>
      <Label className="block mt-6">Store Layout</Label>
      <div className="grid sm:grid-cols-3 gap-3 mt-2">
        {LAYOUTS.map((l) => (
          <button
            key={l.id}
            type="button"
            onClick={() => setField("layout", l.id)}
            className={`text-left p-4 rounded-xl border-2 transition-colors ${(form.layout || "grid") === l.id ? "border-primary-500 bg-primary-50" : "border-gray-100 hover:border-gray-200"}`}
            data-testid={`layout-option-${l.id}`}
          >
            <l.icon className="w-5 h-5 text-primary-600 mb-2" />
            <p className="font-semibold text-gray-900">{l.label}</p>
            <p className="text-xs text-gray-500">{l.desc}</p>
          </button>
        ))}
      </div>
    </fieldset>
  </div>
);
